module.exports = __webpack_public_path__ + "cottage_x.c326b1bf0da4c6e84408101f7cd3b17b.jpg";